import React, { useState } from "react";
import "./CompaniesList.css";
import { Company } from "../../../../types/Company";
import CompanyItem from "./CompanyItem/CompanyItem";
import { useChat } from "../../Layout/ChatProvider/ChatProvider";

const CompaniesList: React.FC = () => {
    const [selectedCompanyId, setSelectedCompanyId] = useState<string | null>(localStorage.getItem("selectedCompanyId"));
    const { filteredCompanies, setCompanyId, setCompany, searchQuery, operatorUsers } = useChat();

    const handleCompanySelect = (company: Company) => {
        setSelectedCompanyId(company.id);
        localStorage.setItem("selectedCompanyId", company.id);
        setCompanyId(company.id);
        setCompany(company);
    };

    const displayedCompanies = filteredCompanies.filter((company) => {
        const query = searchQuery.trim().toLowerCase();

        // Search by company name
        const companyNameMatches = company.name.toLowerCase().includes(query);

        // Search by operator user name if operator_user_id exists
        let operatorNameMatches = false;
        if (company.operator_user_id) {
            const operatorUser = operatorUsers.find(user => user.id === Number(company.operator_user_id));
            if (operatorUser) {
                const operatorFullName = `${operatorUser.first_name} ${operatorUser.last_name}`.toLowerCase();
                operatorNameMatches = operatorFullName.includes(query);
            }
        }

        return companyNameMatches || operatorNameMatches;
    });

    return (
        <div className="company-list-container">
            <div className="company-list">
                {displayedCompanies.length === 0 && searchQuery && (
                    <div className="no-companies">לא נמצאו תוצאות</div>
                )}
                {displayedCompanies.map((company) => (
                    <CompanyItem
                        key={company.id}
                        company={company}
                        isSelected={company.id === selectedCompanyId}
                        onSelect={handleCompanySelect}
                    />
                ))}
            </div>
        </div>
    );
};

export default CompaniesList;
